import { CloseOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { useEffect, useState } from "react";
import { SupportTypeExtensionOfficeFile } from "../../../config/Constant";
import { useInfoUser } from "../../../store/UserStore";
import ExcelPreview from "./ExcelPreview/ExcelPreview";
import PdfPreview from "./PdfPreview/PdfPreview";
import TextPreview from "./TextPreview/TextPreview";
import "./style.scss";

const PreviewOfficeModal = ({
  isOpen,
  resourceId,
  fileType,
  onCancel,
  extensions,
  pdfPreviewResourceId,
}) => {

  console.log(resourceId, fileType, extensions, pdfPreviewResourceId);
  
  const { languageMap } = useInfoUser();
  const [loading, setLoading] = useState(false);

  const renderPreview = () => {
    if (!extensions) return null;

    const extensionsLowCase = extensions.toLowerCase();

    const isExcel =
      SupportTypeExtensionOfficeFile.excelTypes.includes(extensionsLowCase);
    if (isExcel) {
      return <ExcelPreview fileId={resourceId} />;
    }

    const isDocument =
      SupportTypeExtensionOfficeFile.documentTypes.includes(extensionsLowCase);
    if (isDocument) {
      return <PdfPreview pdfPreviewResourceId={pdfPreviewResourceId} />;
    }

    const isText =
      SupportTypeExtensionOfficeFile.textTypes.includes(extensionsLowCase);
    if (isText) {
      return <TextPreview fileId={resourceId} />;
    }

    return (
      <div className="unsupported-format">
        <p>Preview is not yet supported for this format.</p>
        <p className="mime-type">(MIME Type: {extensionsLowCase})</p>
      </div>
    );
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onCancel();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [onCancel]);

  return (
    <Modal
      open={isOpen}
      width="100vw"
      bodyStyle={{ padding: 0 }}
      onCancel={onCancel}
      footer={
        <div className="modal-footer">
          <div className="vertical-line" />
          <button onClick={onCancel}>
            <CloseOutlined />
          </button>
        </div>
      }
      closable={false}
      centered
      maskClosable={false}
      className="fullscreen-modal"
    >
      <div className="modal-content-wrapper">
        {loading ? (
          <div className="loading-text">
            <span>{languageMap?.["preview.loading"] ?? "Loading"}</span>
            <span className="dot dot1">.</span>
            <span className="dot dot2">.</span>
            <span className="dot dot3">.</span>
          </div>
        ) : (
          <div className="h-full">{renderPreview()}</div>
        )}
      </div>
    </Modal>
  );
};

export { PreviewOfficeModal };
